(function(){
  if (window.__fdoCartDrawerBridgeReady) return;
  window.__fdoCartDrawerBridgeReady = true;

  function getDrawer(){ return document.querySelector('cart-drawer'); }
  function getCartUrl(){ return (window.routes && routes.cart_url) ? routes.cart_url : '/cart'; }
  function getCartUpdateUrl(){ return (window.routes && routes.cart_update_url) ? routes.cart_update_url : '/cart/update.js'; }
  function money(cents){ try { return Shopify.formatMoney(cents); } catch(e){ return (Math.max(0,cents||0)/100).toFixed(2).replace('.', ',') + ' €'; } }
  function euro(cents){ return (Math.max(0,cents||0)/100).toFixed(2).replace('.', ',') + ' €'; }
  function getISO(){ return document.getElementById('ship-country') ? document.getElementById('ship-country').value : (window.Shopify && Shopify.country) || 'DE'; }
  function countryName(iso){ try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(String(iso || '').toUpperCase()) || iso; } catch(e){ return iso; } }

  function isFeeItem(item){
    var title = (item && (item.product_title || item.title || '')) || '';
    var props = item && item.properties ? item.properties : {};
    return !!(props._fdo_fee || /Engraving\s*&\s*Personalisation|Personalization Side Fee|Personalisation Side Fee/i.test(title));
  }
  function feeForVariant(item, variantId){
    var props = item && item.properties ? item.properties : {};
    return isFeeItem(item) && String(props._fdo_fee_for_variant || '') === String(variantId || '');
  }
  function sideCount(item){
    var p = item && item.properties ? item.properties : {};
    var count = 0;
    var front = String(p['Front creation style'] || '').trim();
    var back = String(p['Back creation style'] || '').trim();
    if(front && front !== 'Blank / no engraving') count += 1;
    if(back && back !== 'Blank / no engraving') count += 1;
    return count;
  }
  function getFeeRows(drawer){
    return Array.prototype.slice.call(drawer.querySelectorAll('.cart-item')).filter(function(row){
      var title = row.querySelector('.cart-item__name');
      return title && /Engraving\s*&\s*Personalisation|Personalization Side Fee|Personalisation Side Fee/i.test(title.textContent || '');
    });
  }
  function getFeeTotalFromCart(cart){ return (cart.items || []).reduce(function(sum,item){ return isFeeItem(item) ? sum + (item.final_line_price || item.line_price || 0) : sum; },0); }

  function emptyDrawerHtml(){
    return '<div class="drawer__header">' +
      '<h2 class="drawer__heading">Your cart</h2>' +
      '<button class="drawer__close" type="button" onclick="this.closest(\'cart-drawer\').close()" aria-label="Close"><span class="svg-wrapper">×</span></button>' +
      '</div>' +
      '<div class="drawer__inner-empty">' +
      '<div class="cart-drawer__warnings center"><div class="cart-drawer__empty-content">' +
      '<h2 class="cart__empty-text">Your cart is empty</h2>' +
      '<a href="/collections/all" class="button">Continue shopping</a>' +
      '</div></div></div>';
  }
  function updateHeaderCartCount(count){
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child').forEach(function(el){ el.textContent = count; });
    document.querySelectorAll('.cart-count-bubble').forEach(function(el){ el.style.display = count > 0 ? '' : 'none'; });
  }

  function renderEmptyDrawer(){
    var drawer = getDrawer();
    if(!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if(inner) inner.innerHTML = emptyDrawerHtml();
    drawer.classList.add('is-empty','animate','active');
    document.body.classList.add('overflow-hidden');
    updateHeaderCartCount(0);
  }

  function refreshDrawerFromCart(){
    return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      if(!cart.item_count){
        renderEmptyDrawer();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return;
      }
      updateHeaderCartCount(cart.item_count);
      return fetch(getCartUrl() + '?section_id=cart-drawer', { credentials:'same-origin' })
        .then(function(r){ return r.text(); })
        .then(function(htmlText){
          var html = new DOMParser().parseFromString(htmlText, 'text/html');
          var newInner = html.querySelector('.drawer__inner');
          var drawer = getDrawer();
          var oldInner = drawer && drawer.querySelector('.drawer__inner');
          if(newInner && oldInner) oldInner.replaceWith(newInner);
          if(drawer){ drawer.classList.remove('is-empty'); drawer.classList.add('animate','active'); }
          document.body.classList.add('overflow-hidden');
          improveCartDrawer();
          initShippingEstimator();
          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
    });
  }

  function updateCartByKeys(updates){
    return fetch(getCartUpdateUrl(), {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({updates: updates, sections_url: window.location.pathname})
    }).then(function(r){return r.json();}).then(function(){ return refreshDrawerFromCart(); });
  }
  function smartChange(line, quantity){
    line = Number(line); quantity = Number(quantity);
    if(!line) return;
    return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      var target = cart.items[line - 1];
      if(!target) return refreshDrawerFromCart();
      var updates = {};
      updates[target.key] = Math.max(0, quantity);
      if(!isFeeItem(target)){
        var sides = sideCount(target);
        (cart.items || []).forEach(function(item){ if(feeForVariant(item, target.variant_id)) updates[item.key] = quantity <= 0 ? 0 : sides * Math.max(1, quantity); });
      }
      return updateCartByKeys(updates);
    }).catch(function(e){ console.error('FDO cart update failed', e); return refreshDrawerFromCart(); });
  }

  function improveCartDrawer(){
    var drawer = getDrawer();
    if(!drawer) return;
    getFeeRows(drawer).forEach(function(row){ row.classList.add('is-fdo-fee'); });
    var oldSummary = drawer.querySelector('.fdo-cart-service-summary');
    if(oldSummary) oldSummary.remove();
    fetch('/cart.js', {credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      if(!cart.item_count) return;
      var feeCents = getFeeTotalFromCart(cart);
      if(feeCents > 0){
        var summary = document.createElement('div');
        summary.className = 'fdo-cart-service-summary';
        summary.innerHTML = '<div><strong>Personalisation service</strong><span>Selected engraving work is included in your total.</span></div><div class="fdo-cart-service-summary__price">'+euro(feeCents)+'</div>';
        var totals = drawer.querySelector('.cart-drawer__footer .totals') || drawer.querySelector('.totals');
        if(totals && totals.parentNode && !drawer.querySelector('.fdo-cart-service-summary')) totals.parentNode.insertBefore(summary, totals);
      }
    }).catch(function(){});
    var ctas = drawer.querySelector('.cart__ctas');
    if(ctas && !ctas.querySelector('.fdo-cart-ready-line')){
      var line = document.createElement('p');
      line.className = 'fdo-cart-ready-line';
      line.textContent = 'Made personal. Packed beautifully. Ready to gift.';
      ctas.insertBefore(line, ctas.firstChild);
    }
    var icons = drawer.querySelector('.payment-icons');
    if(icons && !icons.querySelector('.fdo-cart-payment-text')){
      Array.prototype.slice.call(icons.querySelectorAll('img')).forEach(function(img){ img.style.display='none'; });
      var text = document.createElement('div');
      text.className = 'fdo-cart-payment-text';
      text.innerHTML = '<span>Visa</span><span>Mastercard</span><span>PayPal</span><span>Klarna</span>';
      icons.appendChild(text);
    }
  }

  function getProvinceSelect(){ return document.getElementById('ship-province'); }
  function getZipInput(){ return document.getElementById('ship-postal'); }
  function getRatesOut(){ return document.getElementById('ship-rates'); }
  function getShipCountry(){ return document.getElementById('ship-country'); }
  function initShippingEstimator(){
    var btn = document.getElementById('ship-check');
    var sel = getShipCountry();
    if(!btn || !sel) return;
    var zip = getZipInput();
    var prov = getProvinceSelect();
    if(zip && !zip.placeholder) zip.placeholder = 'Postal code';
    if(!btn.dataset.fdoReady){ btn.dataset.fdoReady = '1'; btn.addEventListener('click', fetchShippingRates); }
    if(!sel.dataset.fdoReady){
      sel.dataset.fdoReady = '1';
      sel.addEventListener('change', function(){
        var out = getRatesOut();
        if(zip){ zip.value=''; zip.style.display='none'; }
        if(prov){ prov.value=''; prov.style.display='none'; }
        if(out) out.textContent = 'Shipping calculated at checkout.';
      });
    }
    if(zip && !zip.dataset.fdoReady){ zip.dataset.fdoReady='1'; zip.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); fetchShippingRates(); } }); }
  }
  function renderRates(rates){
    var out = getRatesOut();
    if(!out) return;
    if(!rates || !rates.length){ out.textContent = 'No shipping rates found for this destination.'; return; }
    var ul = document.createElement('ul');
    ul.className = 'shipping-rate-list';
    rates.forEach(function(r, index){
      var priceCents = Math.round(parseFloat(r.price || 0) * 100);
      var li = document.createElement('li');
      li.className = 'shipping-rate-item';
      li.innerHTML = '<label><input type="radio" name="selected_rate" '+(index===0?'checked':'')+'> <span class="rate-name">'+(r.presentment_name || r.name || 'Shipping')+'</span> <span class="rate-price">'+money(priceCents)+'</span></label>';
      var input = li.querySelector('input');
      input.addEventListener('change', function(){ updateGrandTotalWithShipping(priceCents); });
      ul.appendChild(li);
      if(index === 0) updateGrandTotalWithShipping(priceCents);
    });
    out.innerHTML = '';
    out.appendChild(ul);
  }
  function updateGrandTotalWithShipping(shippingCents){
    fetch('/cart.js', {credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      var total = document.getElementById('cart-total');
      if(total) total.textContent = money((cart.total_price || 0) + (shippingCents || 0));
    });
  }
  function fetchShippingRates(){
    var out = getRatesOut();
    var zip = getZipInput();
    var prov = getProvinceSelect();
    var iso = getISO();
    if(!out) return;
    var params = new URLSearchParams();
    params.set('shipping_address[country]', countryName(iso));
    if(zip && zip.style.display !== 'none' && zip.value.trim()) params.set('shipping_address[zip]', zip.value.trim());
    if(prov && prov.style.display !== 'none' && prov.value.trim()) params.set('shipping_address[province]', prov.value.trim());
    out.textContent = 'Checking rates…';
    fetch('/cart/shipping_rates.json?' + params.toString(), { credentials:'same-origin', headers:{Accept:'application/json'} })
      .then(function(res){ return res.text().then(function(text){ var data={}; try{data=JSON.parse(text)}catch(e){}; return {ok:res.ok,data:data}; }); })
      .then(function(result){
        if(result.ok){ renderRates(result.data.shipping_rates || []); return; }
        var data = result.data || {};
        if(data.zip && zip){ zip.style.display=''; zip.placeholder = data.zip[0] || 'Postal code'; zip.focus(); out.textContent = 'Enter your postal code, then check rates again.'; return; }
        if(data.province && prov){ prov.style.display=''; out.textContent = 'Select your state/region, then check rates again.'; return; }
        var key = Object.keys(data)[0];
        out.textContent = key && data[key] && data[key][0] ? data[key][0] : 'No shipping rates found for this destination.';
      })
      .catch(function(e){ console.error('FDO shipping rates failed', e); out.textContent = 'There was a problem calculating shipping. Please try again.'; });
  }

  document.addEventListener('click', function(e){
    var drawer = getDrawer();
    if(!drawer || !drawer.contains(e.target)) return;
    var qtyBtn = e.target.closest('.quantity__button');
    if(qtyBtn){
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var item = qtyBtn.closest('.cart-item');
      var input = item && item.querySelector('.quantity__input');
      if(!input) return;
      var current = parseInt(input.value || '0', 10) || 0;
      var next = qtyBtn.name === 'plus' ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      smartChange(input.dataset.index, next);
      return;
    }
    var removeBtn = e.target.closest('cart-remove-button button, cart-remove-button');
    if(removeBtn){
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var remove = e.target.closest('cart-remove-button');
      if(remove) smartChange(remove.dataset.index, 0);
    }
  }, true);
  document.addEventListener('change', function(e){
    var drawer = getDrawer();
    if(!drawer || !drawer.contains(e.target) || !e.target.matches('.quantity__input')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    smartChange(e.target.dataset.index, Math.max(0, parseInt(e.target.value || '0', 10) || 0));
  }, true);
  document.addEventListener('DOMContentLoaded', function(){ improveCartDrawer(); initShippingEstimator(); var drawer = getDrawer(); if(drawer){ new MutationObserver(function(){ improveCartDrawer(); initShippingEstimator(); }).observe(drawer,{childList:true,subtree:true}); } });
  document.addEventListener('cart:updated', function(){ setTimeout(function(){ improveCartDrawer(); initShippingEstimator(); }, 80); });
})();